import { render, staticRenderFns } from "./AddActiveDialog.vue?vue&type=template&id=32d2b63a&scoped=true"
import script from "./AddActiveDialog.vue?vue&type=script&lang=js"
export * from "./AddActiveDialog.vue?vue&type=script&lang=js"
import style0 from "./AddActiveDialog.vue?vue&type=style&index=0&id=32d2b63a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d2b63a",
  null
  
)

export default component.exports